//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { searchCuralateCatalogProducts } from '@apis/universal-image-actions/universalImageActionsApi';
import { CuralateCatalogProducts } from '@apis/universal-image-actions/universalImageActionsApiModel';
import ClientId from '@models/ClientId';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export interface ProductsParams {
  catalogClientId?: ClientId;
  hasCatalog: boolean;
  limit: number;
  offset: number;
  search: string;
}

export const useProductsQuery = ({
  catalogClientId,
  hasCatalog,
  limit,
  offset,
  search,
}: ProductsParams) =>
  useQuery<CuralateCatalogProducts>({
    enabled: hasCatalog,
    queryFn: async ({ signal }) => {
      return searchCuralateCatalogProducts(
        { catalogClientId, limit, offset, search },
        { signal },
      );
    },
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersProducts,
      {
        catalogClientId,
        limit,
        offset,
        search,
      },
    ],
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
